import { createSelector } from 'reselect';
import { ITEMS_PER_PAGE, suggestModalReducerKey } from './SuggestModalConstants';

export const suggestModal = (state) => state.get(suggestModalReducerKey);

export const isLoading = (state) => suggestModal(state).get('isLoading');

export const isNextPageLoading = (state) => suggestModal(state).get('isNextPageLoading');

export const opModel = (state) => suggestModal(state).get('opModel');

export const noData = (state) => suggestModal(state).get('noData');

export const currentDB = (state) => suggestModal(state).get('currentDB');

export const highlightedItem = (state) => suggestModal(state).get('highlightedItem');

export const currentPage = (state) => suggestModal(state).get('currentPage');

export const expandedValue = (state) => suggestModal(state).get('expandedValue');

export const fullUpdate = (state) => suggestModal(state).get('fullUpdate');

export const suggestConfig = (state) => suggestModal(state).get('suggestConfig');

// eslint-disable-next-line no-shadow
export const maxPage = createSelector([opModel], (opModel) => Math.ceil(opModel.groupCount / ITEMS_PER_PAGE));
